// extracted by mini-css-extract-plugin
export default {"base":"Checkbox_base__gKD6r","actualCheckbox":"Checkbox_actualCheckbox__yBL85","srOnly":"Checkbox_srOnly__9DWNy","svgContainer":"Checkbox_svgContainer__ZQ-eC"};